import React from 'react';
import BudgetEditorDrawer from 'components/admin/Budget/BudgetEditor/BudgetEditorDrawer';

// Shim retro-compatible. La implementación fue extraída a BudgetEditorDrawer
// (usa el mismo contrato pero acepta también el modo create standalone).
function PresupuestoFromHallazgosDrawer({
  open,
  hallazgos = [],
  clienteNombre,
  onClose,
  onSuccess,
}) {
  return (
    <BudgetEditorDrawer
      open={open}
      hallazgos={hallazgos}
      clienteNombre={clienteNombre}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
}

export default PresupuestoFromHallazgosDrawer;
